import { CREATED_THROUGH } from "@hub/plan/src/constants"

export default {
  addNewComboCampaignSelected({ state, commit }, newCampaign) {
    const NEW_CAMPAIGNS = [...state.comboCampaignSelecteds]
    NEW_CAMPAIGNS.push(newCampaign)
    commit("setComboCampaignSelecteds", NEW_CAMPAIGNS)
  },
  deleteComboCampaignSelected({ state, commit }, indexToRemove) {
    const NEW_CAMPAIGNS = [...state.comboCampaignSelecteds]
    NEW_CAMPAIGNS.splice(indexToRemove, 1)
    commit("setComboCampaignSelecteds", NEW_CAMPAIGNS)
  },
  toggleComboCampaignOptionsDisabled({ state, commit }, valueOption) {
    const NEW_OPTIONS = [...state.comboCampaignOptions]
    const INDEX_OPTION_TO_MODIFY = NEW_OPTIONS.findIndex(
      option => option.value === valueOption
    )
    NEW_OPTIONS[INDEX_OPTION_TO_MODIFY].disabled =
      !NEW_OPTIONS[INDEX_OPTION_TO_MODIFY].disabled
    commit("setComboCampaignOptions", NEW_OPTIONS)
  },

  fillComboEditing({ state, commit }, combo) {
    commit("setComboName", combo.name)
    commit("setComboCommercialName", combo.trade_name)
    commit("setComboCategorySelected", combo.service_type.uuid)
    if (combo.movements.length) {
      commit("setComboMovementSelected", combo.movements[0]?.uuid)
    }
    commit("setComboScore", combo.score)
    commit("setComboPhysicalPerson", combo.physical_marketable)
    commit("setComboLegalPerson", combo.legal_marketable)
    commit("setComboActive", combo.active)
    commit("setComboRecommended", combo.highlighted)
    commit("setComboShouldBeDisplayed", combo.marketable)
    commit("setComboCreatedThrough", combo.created_through || CREATED_THROUGH.INTEGRATION)
    if (combo.icon) {
      commit("setComboIconPreview", {
        url: combo.icon,
        icon: "",
        name: "icon",
        type: "image/png"
      })
    }
    commit(
      "setComboPlansSelecteds",
      combo.package_plans.map(plan => ({
        icon: plan.icon,
        name: plan.name,
        value: plan.uuid,
        text: plan.name,
        price: plan.original_value,
        value_promotional: plan.value
      }))
    )
    commit(
      "setComboCampaignSelecteds",
      combo.campaigns.map(campaign => ({
        ...campaign,
        text: campaign.name,
        value: campaign.uuid
      }))
    )
    commit(
      "setComboCoverageStatesSelecteds",
      combo.states.map(state => ({
        text: state.name,
        value: state.id,
        price: state.value,
        uuid: state.id
      }))
    )
    commit(
      "setComboCoverageCitySelecteds",
      combo.cities.map(city => ({
        text: city.name,
        value: city.uuid,
        price: city.value,
        state: city.state
      }))
    )
    commit(
      "setComboCoverageDddsSelecteds",
      combo.area_codes.map(areaCode => ({
        text: areaCode.code,
        value: areaCode.uuid,
        price: areaCode.value
      }))
    )
    commit(
      "setComboAccessChainsSelecteds",
      combo.chains.map(chain => ({
        text: chain.name,
        value: chain.uuid
      }))
    )
    commit(
      "setComboAccessPosSelecteds",
      combo.pos.map(p => ({
        text: p.name,
        value: p.uuid
      }))
    )
    commit(
      "setComboDiscountPaymentSelecteds",
      combo.discounts.payment.map(payment => ({
        type: payment.criteria,
        text: payment.type_name,
        value: payment.type,
        price: payment.value
      }))
    )
    commit(
      "setComboDiscountShippingSelecteds",
      combo.discounts.shipping.map(shipping => ({
        type: shipping.criteria,
        text: shipping.type_name,
        value: shipping.type,
        price: shipping.value
      }))
    )
  }
}
